import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private data = new BehaviorSubject<sharedDataType>({});
  public sharedData = this.data.asObservable();

  constructor() {

  }

  clearSharedData() {
    this.data = new BehaviorSubject<any>({});
    this.sharedData = this.data.asObservable();
  }

  nextSharedData(data: sharedDataType) {
    this.data.next(data);
  }

  setDataEmployeeEditAction(action: any) {
    this.data = new BehaviorSubject<any>({ action: action });
    this.sharedData = this.data.asObservable();
  }
}
